
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { OrderStage } from '@/types/reportOrder';
import { UserModule } from '@/store/modules/user';
import { AppModule } from '@/store/modules/app';
import {
  getOrderList,
  getAllOrderList,
  exportOrder,
  exportOrderAll
} from '@/api/order';

import dialogImgLarge from '@/components/ImgLarge/index.vue';
import buttonList from '@/components/ButtonList/index.vue';
// import DrawerDetail from '@/components/Drawer/DrawerDetail.vue';

import { parseTime } from '@/utils';
import eventBus from '@/utils/eventBus';
import { checkPermissionRole } from '@/utils/permission';
import { Type } from '@/types/permissionType';
import { checkOrderPass, orderCheckClose } from '@/api/orderCheck';

@Component({
  name: 'OrderList',
  components: {
    dialogImgLarge,
    buttonList,
    // DrawerDetail,
  }
})
export default class extends Vue {
  // 订单类型参数定义
  @Prop({
    type: Number,
    default: OrderStage.UNDERWAY,
    required: true,
    validator: (value:any) => {
      return OrderStage[value] !== undefined;
    }
  })
  public stage!: OrderStage;

  @Prop({
    type: Boolean,
    default: false,
    required: false
  })
  private all!: Boolean;

  @Prop({
    type: Boolean,
    default: false,
    required: false
  })
  private showStatus!: Boolean;

  get getOrderList(): Function {
    if (this.all) { // 所有报修
      return getAllOrderList;
    } else { // 我的订单
      return getOrderList;
    }
  }

  // 导出
  private exportOrderHandle() {
    if (this.all) {
      this.exportOrderAll();
    } else {
      this.exportOrder();
    }
  }
  private searchParams:any='';
  private exportOrderAll() {
    if (!this.searchParams.start_time || !this.searchParams.end_time) {
      this.showErrorMsg('请选择开始时间和结束时间，搜索之后导出');
      return;
    }
    if (parseInt(this.searchParams.end_time) - parseInt(this.searchParams.start_time) > (31 * 24 + 24) * 60 * 60) {
      this.showErrorMsg('最多选择一个月数据导出');
      return;
    }
    let pamars:any = {};
    pamars.start_time = this.searchParams.start_time;
    pamars.end_time = this.searchParams.end_time;
    pamars.user_id = UserModule.getUserId;
    pamars.user_name = UserModule.getUserName;
    pamars.company_id = UserModule.getCompanyId;
    pamars.company_name = UserModule.getCompanyName;
    pamars.name = this.searchParams.name;
    pamars.order_num = this.searchParams.order_num;
    pamars.stage = this.stage;
    pamars.type = this.stage === OrderStage.ALL ? 'all'
      : this.stage === OrderStage.UNDERWAY ? 'underway'
        : this.stage === OrderStage.UNCONFIRMED ? 'toConfirm'
          : this.stage === OrderStage.UNCOMMENT ? 'toEvaluate' 
            : this.stage === OrderStage.COMPLETED ? 'finish' : '';
    exportOrderAll(pamars).then(res => {
      this.$confirm('是否跳转下载页面？', '跳转', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let routeData = this.$router.resolve({
          path: '/ExportTask',
          query: {}
        });
        window.open(routeData.href);
      }).catch(() => {

      });
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  private exportOrder() {
    if (!this.searchParams.start_time || !this.searchParams.end_time) {
      this.showErrorMsg('请选择开始时间和结束时间，搜索之后导出');
      return;
    }
    if (parseInt(this.searchParams.end_time) - parseInt(this.searchParams.start_time) > (31 * 24 + 24) * 60 * 60) {
      this.showErrorMsg('最多选择一个月数据导出');
      return;
    }
    let pamars:any = this.searchParams;
    pamars.user_id = UserModule.getUserId;
    pamars.user_name = UserModule.getUserName;
    pamars.company_id = UserModule.getCompanyId;
    pamars.company_name = UserModule.getCompanyName;
    pamars.stage = this.stage;
    pamars.type = this.stage === OrderStage.ALL ? 'all'
      : this.stage === OrderStage.UNDERWAY ? 'underway'
        : this.stage === OrderStage.UNCONFIRMED ? 'toConfirm'
          : this.stage === OrderStage.UNCOMMENT ? 'toEvaluate' 
            : this.stage === OrderStage.COMPLETED ? 'finish' : '';
    exportOrder(pamars).then(res => {
      this.$confirm('是否跳转下载页面？', '跳转', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let routeData = this.$router.resolve({
          path: '/ExportTask',
          query: {}
        });
        window.open(routeData.href);
      }).catch(() => {

      });
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }
  private dropdownOptions = [
    {
      value: '批量寄出'
    }
  ];

  private checkPermission(val:any) {
    return checkPermissionRole(UserModule.getCompanyId, Type.InsteadCheckPass)
  }

  created() {
    // 当搜索组件触发这个事件后，刷新列表
    let that = this;
    eventBus.$on('orderSearch', function(data:any) {
      that.searchParams = data;
      that.pagination.currentPage = 1;
      if (that.sending) {
        that.getSendList();
      } else {
        that.getList();
      }
    });

    this.$once('hook:beforeDestroy', () => {
      // 在离开页面的时候注销掉该eventBus的事件，否则会在多个页面中重复请求
      eventBus.$off('orderSearch');
    });
  }

  @Watch('showEvaluated', { deep: true, immediate: true })
  onShowEvaluatedChange() {
    if (this.sending) {
      this.getSendList();
    } else {
      this.getList();
    }
  }

  get showMoreBtn() {
    return (
      this.stage === OrderStage.COMPLETED ||
        this.stage === OrderStage.UNDERWAY ||
        this.stage === OrderStage.UNCOMMENT ||
        this.stage === OrderStage.UNCONFIRMED || this.stage === OrderStage.ALL
    );
  }

  get showEvaluated() {
    return AppModule.evaluated;
  }

  // 页面参数定义
  private pagination:any = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  };

  private sending = false;
  private orderSelected = [];
  private orderSelectedAll = false;
  private isIndeterminate: any = null;

  // 列表内容定义
  private listLoading = false;
  private orderList: any[] = [];

  private checkOrderPass(val:any) {
    this.$prompt('请输入备注', '订单通过', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      // inputPattern: /^.{1,100}$/,
      inputErrorMessage: '请输入1-100字符'
    }).then(({ value }: any) => {
      let p:any = {};
      p.user_id = UserModule.getUserId;
      p.company_id = UserModule.getCompanyId;
      p.user_name = UserModule.getUserName;
      p.order_id = val.order.id;
      p.remark = value;
      p.is_instead_check = 1;
      checkOrderPass(p).then(res => {
        this.getList();
        this.showSuccessMsg('操作成功');
      }).catch(err => {
        this.showErrorMsg(err.msg);
      });
    }).catch(() => {
      // this.$message({
      //   type: 'info',
      //   message: '取消输入'
      // });
    });
  }

  private orderCheckClose(val:any) {
    this.$prompt('请输入备注', '订单驳回', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      inputPattern: /^.{1,100}$/,
      inputErrorMessage: '请输入1-100字符'
    }).then(({ value }: any) => {
      let p:any = {};
      p.user_id = UserModule.getUserId;
      p.company_id = UserModule.getCompanyId;
      p.user_name = UserModule.getUserName;
      p.order_id = val.order.id;
      p.remark = value;
      p.is_instead_check = 1;
      orderCheckClose(p).then(res => {
        this.getList();
        this.showSuccessMsg('操作成功');
      }).catch(err => {
        this.showErrorMsg(err.msg);
      });
    }).catch(() => {
      // this.$message({
      //   type: 'info',
      //   message: '取消输入'
      // });
    });
  }

  private handBtngroupMore(val: any) {
    this.sending = true;
    this.getSendList();
  }
  private sendHandle() {
    if (this.orderSelected.length > 0) {
      this.orderSelectedAll = false;
      this.sending = false;
      this.getOrderList();
      this.$router.push({
        path: '/order/send',
        query: { 'orderDetailList': JSON.stringify(this.orderSelected) }
      });
    } else {
      this.$notify({
        title: '提示',
        message: '请选择需要寄出的订单',
        type: 'warning'
      });
    }
  }
  private cancelSendHandle() {
    this.orderSelectedAll = false;
    this.orderSelected = [];
    this.sending = false;
    this.getList();
    // 同时重新获取数据
  }
  private getSendList() {
    this.listLoading = true;
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      page: this.pagination.currentPage,
      size: this.pagination.pageSize,
      stage: this.stage,
      armed_state: 1,
      // 接收到搜索组建传递过来的参数，并解析，如果没有，纠结吸不出来...也就是没有参数
      ...this.searchParams
    };
    this.getOrderList(params)
      .then((res: any) => {
        const data = res.data;
        if (data !== null) {
          this.pagination.total = data.count || 0;
          this.orderList = data.list;
        } else {
          this.pagination.total = 0;
          this.orderList = [];
        }
        this.listLoading = false;
      })
      .catch((err: any) => {
        this.listLoading = false;
        let msg = err.msg;
      });
  }
  private getList() {
    this.orderList = [];
    this.listLoading = true;
    let defaultTime: any = {};
    if (this.stage === 5 || this.stage === 0) {
      // 报修日期默认当前时间一年内
      let y = new Date().getFullYear();
      let flag = y % 400 === 0 || (y % 4 === 0 && y % 100 !== 0);
      let yyyy = 365;
      if (flag) {
        yyyy = 366;
      }
      defaultTime = {
        start_time: parseTime(new Date().getTime() - 1000 * 60 * 60 * 24 * (yyyy - 1), '{y}-{m}-{d}'),
        end_time: parseTime(new Date(), '{y}-{m}-{d}')
      };
      defaultTime.start_time = new Date(defaultTime.start_time.replace(/-/g, '/') + ' 00:00').getTime().toString().substring(0, 10);
      defaultTime.end_time = new Date(defaultTime.end_time.replace(/-/g, '/') + ' 23:59').getTime().toString().substring(0, 10);
    }

    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId ? UserModule.getCompanyId : '0',
      page: this.pagination.currentPage,
      size: this.pagination.pageSize,
      stage: this.stage,
      ...defaultTime,
      ...this.searchParams
    };

    this.getOrderList(params)
      .then((res: any) => {
        const data = res.data;
        if (data !== null) {
          this.pagination.total = data.count || 0;
          this.orderList = data.list;
        } else {
          this.pagination.total = 0;
          this.orderList = [];
        }
        this.listLoading = false;
        this.$store.dispatch('CloseEvaluated', false);
      })
      .catch((err: any) => {
        this.listLoading = false;
        let msg = err.msg;
      });
  }

  getTagsHtml(r: any) {
    let kind = '';
    let kindType = '';
    let plain = 'plain';
    let abnormal = "";
    if (parseInt(r.order.order_type) === 1) {
      kind = '其他';
      kindType = 'warning';
    } else if (parseInt(r.order.order_type) === 2) {
      kind = '维保';
      kindType = 'success';
    } else if (parseInt(r.order.order_type) === 3) {
      kind = '安装';
      kindType = 'danger';
    } else if (parseInt(r.order.order_type) === 4) {
      kind = '巡检';
      kindType = '';
      if (parseInt(r.order_service.polling_check_abnormal_count) > 0) {
        abnormal = "巡异";
      }
    } else {
      kind = '维保';
      kindType = 'success';
    }

    let charge = '';
    let darkplain = 'dark';
    if (parseInt(r.order_service.charge) === 1) {
      charge = '收费';
    }

    let expedited = '';
    if (parseInt(r.order_service.expedited) === 1) {
      expedited = '加急';
    }

    // 2019-05-23 迭代 订单排位
    var ranking = '';
    if (parseInt(r.order_service.is_ranking) === 1) {
      var rankingNum = parseInt(r.order_service.ranking);
      if (rankingNum) {
        ranking = rankingNum + '号';
      }
    }

    // 审核标识
    let check = '';
    if (
      parseInt(r.order.check_state) === 11 ||
      parseInt(r.order.check_state) === 51
    ) {
      check = '审核';
    }

    return [
      {
        type: kindType,
        label: kind,
        plain: plain
      },
      {
        type: "danger",
        label: abnormal,
        plain: darkplain,
      },
      {
        type: 'danger',
        label: charge,
        plain: darkplain
      },
      {
        type: 'danger',
        label: expedited,
        plain: darkplain
      },
      {
        type: 'danger',
        label: ranking,
        plain: darkplain
      },
      {
        type: 'warning',
        label: check,
        plain: darkplain
      }
    ];
  }

  handleCurrentChange(size: number) {
    this.pagination.currentPage = size;
    if (this.sending) {
      this.getSendList();
    } else {
      this.getList();
    }
  }

  handlePageSizeChange(size: number) {
    this.pagination.pageSize = size;
    if (this.sending) {
      this.getSendList();
    } else {
      this.getList();
    }
  }

  private handleCheckAllChange(val: boolean) {
    let orderOptions: any = [];

    if (val) {
      for (let i = 0; i < this.orderList.length; i++) {
        orderOptions.push(this.orderList[i]);
      }
    } else {
      orderOptions = [];
    }
    this.orderSelected = orderOptions;
    this.isIndeterminate = false;
  }
  private handleCheckedOrderChange(val: any) {
    let checkedCount = val.length;
    let _length = this.orderList.length;
    this.orderSelectedAll = checkedCount === _length;
    this.isIndeterminate = checkedCount > 0 && checkedCount < _length;
  }

  private allPDFHandle(val:any) {
    // 工作单导出
    const url = val.order.order_elec.save_path as string;
    const filename = url.split('/').slice(-1)[0];
    if ('download' in document.createElement('a')) {
      // 非IE下载
      let elink = document.createElement('a');
      elink.download = filename;
      elink.style.display = 'none';
      elink.href = url;
      elink.target = '_blank';
      document.body.appendChild(elink);
      elink.click();
      URL.revokeObjectURL(elink.href); // 释放URL 对象
      document.body.removeChild(elink);
    } else {
      // IE10+下载
      // navigator.msSaveBlob(blob, fileName);
    }
    this.$message.success('下载文件成功');
  }

  private showDrawerDetails = false;
  private DetailsDataQuery: any = {};
  private closeDrawerDetail(val:boolean) {
    this.showDrawerDetails = val
  }
  detailHandle(val: any, index: number) {
    let routeData = this.$router.resolve({
      path: '/order/orderToDetail',
      query: {
        order_service_id: val.order_service.id,
        orderId: val.order.id,
        all: this.all ? '1' : '0',
        showComplaintBtn: this.showMoreBtn ? '1' : '0',
        tabName: index === 2 ? 'schedule' : 'infor'
      }
    });
    window.open(routeData.href);

    // this.showDrawerDetails = true;
    // this.DetailsDataQuery = {
    //   order_service_id: val.order_service.id,
    //   orderId: val.order.id,
    //   all: this.all ? '1' : '0',
    //   showComplaintBtn: this.showMoreBtn ? '1' : '0',
    //   tabName: index === 2 ? 'schedule' : 'infor'
    // };
  }

  private imgLargeHandle(val: [], index: number) {
    let enlargedData = {
      isShow: true,
      imgList: val,
      initNum: index
    };
    this.$store.dispatch('toggleEnlarged', enlargedData);
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
